export const setPageTitle = (pageTitle) => {
  // *********************  Mobile app stuff ***********************
  // For Android
  if (window.androidObj == undefined) {
    window.androidObj = function AndroidClass() {};
  }

  if (window.androidObj.setPageTitle !== undefined) {
    window.androidObj.setPageTitle(pageTitle);
  }
  //  =================IOS======================================
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.setPageTitle
  ) {
    window.webkit.messageHandlers.setPageTitle.postMessage({
      title: pageTitle,
    });
  }
  //  ===========================================================
};

export const logout = () => {
  localStorage.removeItem("driverToken");
  localStorage.removeItem("driver_id");
  localStorage.removeItem("first_name");
  localStorage.removeItem("last_name");
  localStorage.removeItem("ev_charging_site_id");
};
